import { ReactElement, ReactNode } from 'react'
import { Box, Paper, Typography } from '@mui/material'

interface Props {
  title: string
  /** Right-aligned controls next to the title. */
  actions?: ReactNode
  children: ReactNode
  'data-cy'?: string
}

/**
 * A Systemmanager section in the style of the Aufbauten list: the title above (outside) a white
 * box holding the content.
 */
const ManagerSection = ({ title, actions, children, 'data-cy': dataCy }: Props): ReactElement => (
  <Box data-cy={dataCy}>
    <Box display="flex" mb={1} justifyContent="space-between" alignItems="center">
      <Typography variant="h6" mb={1}>
        {title}
      </Typography>
      {actions}
    </Box>
    <Paper sx={{ p: 1.5 }}>{children}</Paper>
  </Box>
)

export default ManagerSection
